/**
 * Pure component for revealing the username to the student.
 */
import React, { FunctionComponent } from 'react';
import NewUserButton from './common/new-user-button';

interface IUsernameRevealProps {
    userName: string; // Username given to the user
    onSubmit: () => void; // Handle submit
}

const UsernameRevealView: FunctionComponent<IUsernameRevealProps> = ({
    userName,
    onSubmit,
}: IUsernameRevealProps) => (
    <div className="new-user-username-reveal-page">
        <div className="new-user-view-content">
            <div className="new-user-view-box username-reveal">
                <p className="new-user-username-reveal-header">
                    This is your username, you&apos;ll use this each time you log in to Sparx
                </p>

                <div className="new-user-username-reveal">{userName}</div>

                <p className="new-user-username-reveal-footer">
                    Make sure you remember your username - you might even want to write it down
                    somewhere
                </p>

                <div className="new-user-view-form-button-group">
                    <NewUserButton
                        type="submit"
                        value="Set a password"
                        handleClick={() => onSubmit()}
                        showIcon={true}
                    />
                </div>
            </div>
        </div>
    </div>
);

export default UsernameRevealView;
